import React from 'react'
import PlayFilter from '../components/PlayFilter/PlayFilter.Component';
import Poster from '../components/Poster/Poster.Component';

 const Play= () =>{
    return (
        <div>
            <div className='container mx-auto px-4'>
                <div className='w-full lg:flex   lg:flex-row-reverse '>
             <div className='lg:w-3/4 p-10 m-4 bg-white rounded-lg '> 
             <h2 className='text-2xl font-bold mb-4'>
                 Play in NCR Delhi
             </h2>
             <div className="flex flex-wrap">
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXA%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00307894-swmrwbmltq-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>            
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='  https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXAgb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00305723-ygbxnzhwwn-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCA5IE9jdA%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00315029-uhmxfrvwgy-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXAgb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00308477-fbpugsqmzb-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXA%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00307894-swmrwbmltq-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>            
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='  https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXAgb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00305723-ygbxnzhwwn-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCA5IE9jdA%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00315029-uhmxfrvwgy-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXAgb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00308477-fbpugsqmzb-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXA%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00307894-swmrwbmltq-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>            
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='  https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXAgb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00305723-ygbxnzhwwn-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCA5IE9jdA%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00315029-uhmxfrvwgy-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>
                 <div className='w-1/2 md:w-1/3 lg:w-3/12 my-3'>
                     <Poster src='https://in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAyNSBTZXAgb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24/et00308477-fbpugsqmzb-portrait.jpg' 
                     title=' Sharafat Chode Di Maine ' alt=' play image'/>
                 </div>

                 
                 
             </div>
             </div>    
                <div className='lg:w-1/4 p-10  m-4 bg-white rounded-lg'>
                    <h2 className='text-2xl font-bold mb-4'>
                            Filters
                    </h2>
                    <div>
                        <PlayFilter title='Date' tags={ ['Today', 'Tommorow', 'This week'] }/>
                    </div>
                    <div>
                        <PlayFilter title='Language' tags={ ['English', 'Hindi', 'Punjabi'] }/>
                    </div>
                </div>
                </div>
            </div>


        </div>
    )
}
export default Play;